<template>
  <div class="haulage-revenue-drill-through-main">
     <!-- Top bar showing filter selections -->
    <div class="filtered-section" id="filtered-section">
    <div class="filtered-items">
      <div class="filtered-row">
        <div class="filter-title-long">Ready for Billing Date</div>
        <div class="colon-separator">:</div>
        <div class="filter-details">{{ this.fromDate }} to {{ this.toDate }}</div>
      </div>
      <div class="filtered-row">
        <div class="filter-title-long">Customer</div>
        <div class="colon-separator">:</div>
        <div class="filter-details">{{ this.selectedCustomerInfo }}</div>
      </div>
    </div>
    <div class="filtered-items">
      <div class="filtered-row">
        <div class="filter-title">Job Type</div>
        <div class="colon-separator">:</div>
        <div class="filter-details"> {{ this.selectedJobTypeInfo }}</div>
      </div>
      <div class="filtered-row">
        <div class="filter-title">Tariff Area</div>
        <div class="colon-separator">:</div>
        <div class="filter-details">{{ this.selectedAreaInfo }}</div>
      </div>
    </div>
    <div class="refresh-section">
      <div v-if="!loading">Last Refreshed : {{ this.refreshDate }}</div>
    </div>
  </div>
    <div class="drill-through-body" id="drill-through-body">
      <TableBox :title="tableTitle" :tableData="drillThroughDetails" :hideColumns="dataColumnsHide" :dataType="columnType" />
    </div>
    <Loader :loadingText="loadText" :isVisible.sync="loading" />
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data() {
    return {
      loading: false,
      loadText: 'Getting details',
      fromDate: '',
      toDate: '',
      getCustomerCode: '',
      getJobType: '',
      getAreaCode: '',
      selectedCustomerInfo: '',
      selectedJobTypeInfo: '',
      selectedAreaInfo: '',
      refreshDate: '',
      drillThroughDetails: [],
      tableTitle: '',
      dataColumnsHide: [],
      columnType: {}
    }
  },
  props: {
  },
  methods: {
    // Get items from session storage
    getAllFromStorage: async function() {
      var details = JSON.parse(sessionStorage.getItem(this.$route.params.drillThroughName));
      this.fromDate = details.fromDate;
      this.toDate = details.toDate;
      this.getCustomerCode = details.getCustomerCode;
      this.getJobType = details.getJobType;
      this.getAreaCode = details.getAreaCode;
      this.selectedJobTypeInfo = details.selectedJobTypeInfo;
      this.selectedCustomerInfo = details.selectedCustomerInfo;
      this.selectedAreaInfo = details.selectedAreaInfo;
      this.refreshDate = details.lastRefresh;
      this.tableTitle = details.title;
    },
    // Format currency (digit grouping & decimal)
    // Data and an array of key/column to format 
    // currencyFormat: function(getDrillThroughData, currencyColumnKey) {
    //   for (var i in currencyColumnKey) {
    //     for (var x in getDrillThroughData){
    //       // Check if the key is present in the data
    //       if (getDrillThroughData[x].hasOwnProperty(currencyColumnKey[i])){
    //         // Format data only when it is not null (prevent TypeError cannot read null)
    //         if (getDrillThroughData[x][currencyColumnKey[i]] != null) {
    //         getDrillThroughData[x][currencyColumnKey[i]] = getDrillThroughData[x][currencyColumnKey[i]].toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    //         }
    //       }
    //     }
    //   }
    // },

    // Format currency (digit grouping, decimal symbol and decimal)
    // Parse in data and an array of key/column to format 
    currencyFormat: function(getDrillThroughData, currencyColumnKey) {
      for (var i in currencyColumnKey) {
        for (var x in getDrillThroughData){
          // Check if the key is present in the data
          if (getDrillThroughData[x].hasOwnProperty(currencyColumnKey[i])){
            // Format the data using function declared as Vue prototype currencyFormat
            getDrillThroughData[x][currencyColumnKey[i]] = (getDrillThroughData[x][currencyColumnKey[i]]);
          }
        }
      }
    },
    // Generate drill through table 
    drillThroughGenerate: async function() {
      if (this.tableTitle.includes('Daily Revenue Details')) {
        var getDrillThroughData = await this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.fromDate}&end=${this.toDate}&datetype=RFB&rpttype=DETAILS&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}`);
        // Columns to hide in tablebox
        this.dataColumnsHide = ["Own Cont", "Outsource Cont", "Own Total", "Outsourced Total"];
        // Columns data type
        this.columnType = {
          '#' : 'number',
          'Date' : 'date',
          'Haulage' : 'currency',
          'Rebate' : 'currency',
          'Haulage after Rebate' : 'currency',
          'Toll' : 'currency',
          'FAF' : 'currency',
          'DGC' : 'currency',
          'Others' : 'currency',
          'Total' : 'currency',
          'Total Billed' : 'currency',
          '20Ft' : 'number',
          '40Ft' : 'number',
          'TEUs' : 'number',
          'Cont' : 'number'
        }
        // Key/Column to format 
        var currencyColumnKey = ["Haulage", "Rebate", "Haulage after Rebate", "Toll", "FAF", "DGC", "Others", "Total", "Total Billed"];
        // Convert currency format
        this.currencyFormat(getDrillThroughData, currencyColumnKey);
        // Tabulate data
        this.drillThroughDetails = getDrillThroughData;

        // Filter of data using loop to map data for table
        // const requiredKey = ["#", "Date","Day","Haulage","Rebate","Haulage after Rebate","Toll","FAF","DGC","Others","Total","Total Billed","20Ft","40Ft","TEUs","Cont"];
        // var drillThroughFiltered = [];
        // for (var i=0;i<drillThrough.data.length;i++) {
        // var filterProperties = (requiredKey, data) => 
        //     requiredKey.reduce((a,x) => data[x] !== undefined ? ({ ...a, [x]: data[x] }) : a, {});

        // drillThroughFiltered.push(filterProperties(requiredKey, drillThrough.data[i]));
        // }
        // this.drillThroughDetails = drillThroughFiltered;
      }
      else if (this.tableTitle.includes('Own and Outsource Details')){
        var getDrillThroughData = await this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.fromDate}&end=${this.toDate}&datetype=RFB&rpttype=DETAILS&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}`);
        // Columns to hide in tablebox
        this.dataColumnsHide = ["Haulage","Rebate","Haulage after Rebate","Toll","FAF","DGC","Others","Total","Total Billed","20Ft","40Ft","TEUs"];        
        // Columns data type
        this.columnType = {
          '#' : 'number',
          'Date' : 'date',
          'Cont' : 'number',
          'Own Cont' : 'number',
          'Outsource Cont' : 'number',
          'Own Total' : 'currency',
          'Outsourced Total' : 'currency'
        }
        // Key/Column to format 
        var currencyColumnKey = ["Own Total", "Outsourced Total"];
        // Convert currency format
        this.currencyFormat(getDrillThroughData, currencyColumnKey);
        // Tabulate data
        this.drillThroughDetails = getDrillThroughData;
        
        // Filter of data using loop to map data for table
        // const requiredKey = ["#", "Date","Day","Cont","Own Cont", "Outsource Cont", "Own Total", "Outsourced Total"];
        // var drillThroughFiltered = [];
        // for (var i=0;i<drillThrough.data.length;i++){
        // var filterProperties = (requiredKey, data) => 
        //     requiredKey.reduce((a,x) => data[x] !== undefined ? ({ ...a, [x]: data[x] }) : a, {});

        // drillThroughFiltered.push(filterProperties(requiredKey, drillThrough.data[i]));
        // }
        // this.drillThroughDetails = drillThroughFiltered;
      }
      else if (this.tableTitle.includes('Top 50 Customers Details')){
        var getDrillThroughData = await this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.fromDate}&end=${this.toDate}&datetype=RFB&rpttype=BY_CUSTOMER&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}&showtopx=50`);
        // Columns data type
        this.columnType = {
          'customer_ranking' : 'number',
          'AmtTotal' : 'currency'
        }
        // Key/Column to format 
        var currencyColumnKey = ["AmtTotal"];
        // Convert currency format
        this.currencyFormat(getDrillThroughData, currencyColumnKey);
        // Tabulate data
        this.drillThroughDetails = getDrillThroughData;
      }
      else if (this.tableTitle.includes('Top 50 Shipper Consignee Details')){
        this.tableTitle = 'Top 50 Shipper/Consignee Details';
        var getDrillThroughData = await this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.fromDate}&end=${this.toDate}&datetype=RFB&rpttype=BY_SHPRCSGN&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}&showtopx=50`);
        // Columns data type
        this.columnType = {
          'customer_ranking' : 'number',
          'AmtTotal' : 'currency'
        }
        // Key/Column to format 
        var currencyColumnKey = ["AmtTotal"];
        // Convert currency format
        this.currencyFormat(getDrillThroughData, currencyColumnKey);
        // Tabulate data
        this.drillThroughDetails = getDrillThroughData;
      }
      else if (this.tableTitle.includes('Monthly Total Containers by Shipper')){
        this.tableTitle = 'Monthly Total Containers by Shipper';
        var getDrillThroughData = await this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.fromDate}&end=${this.toDate}&datetype=RFB&rpttype=TOTALCONT_BY_SHPR&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}&showtopx=50`);
        // Columns data type
        this.columnType = {
          'customer_ranking' : 'number',
          'AmtTotal' : 'number'
        }
        // Key/Column to format 
        var currencyColumnKey = ["AmtTotal"];
        // Convert currency format
        this.currencyFormat(getDrillThroughData, currencyColumnKey);
        // Tabulate data
        this.drillThroughDetails = getDrillThroughData;
      }
      else if (this.tableTitle.includes('Monthly Total Containers by Consignee')){
        this.tableTitle = 'Monthly Total Containers by Consignee';
        var getDrillThroughData = await this.$apiCallV2(`/HaulageRevenue/GetHMSSales?start=${this.fromDate}&end=${this.toDate}&datetype=RFB&rpttype=TOTALCONT_BY_CSGN&jobtypeArray=${this.getJobType}&custArray=${this.getCustomerCode}&areaArray=${this.getAreaCode}&showtopx=50`);
        // Columns data type
        this.columnType = {
          'customer_ranking' : 'number',
          'AmtTotal' : 'number'
        }
        // Key/Column to format 
        var currencyColumnKey = ["AmtTotal"];
        // Convert currency format
        this.currencyFormat(getDrillThroughData, currencyColumnKey);
        // Tabulate data
        this.drillThroughDetails = getDrillThroughData;
      }
      this.loading = false;
    }
  },
  async mounted() {
    this.loading = true;
    // Get items from session storage
    this.getAllFromStorage();

    // Set tablebox height dynamically
    var setTabulatorHeight = 'calc(' + '100%' + ' - ' + $("#filtered-section").height() + 'px';
    $("#drill-through-body").css('height', setTabulatorHeight);
    
    // Generate drill through table
    this.drillThroughGenerate(); 
  },
}
</script>

<style lang="scss" scoped>
  @import '@/css/all.scss';

.haulage-revenue-drill-through-main {
  font-size: 12px;
  padding: 5px 45px;
  display: flex;
  flex-direction: column; 

  > .drill-through-body {
    background-color: white;
    width: 100%;
    border-radius: 5px;
    padding: 5px;
  }
  > .filtered-section {
      width: 100%;  
      height: auto;
      background-color: white;
      border-radius: 5px;
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 3px;
    > .filtered-items {
      width: calc(100% - 250px);
      > .filtered-row {
        display: flex;
        align-items: center;
        > .filter-title-long {
            width: 270px;
            padding-left:3px;
        }
        > .filter-title {
          width: 120px;
          padding-left:3px;
        }
        > .colon-separator {
          margin: 0 5px;
        }
        > .filter-details {
          width: 100%;
        }
      }
    }
    
    > .refresh-section {
      height: 100%;
      min-width: 250px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
      margin-right: 3px;
    }
  }
}
</style>